import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Box, Typography, ButtonGroup, Button, } from '@mui/material';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import ReplyAllOutlinedIcon from '@mui/icons-material/ReplyAllOutlined';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import { useTokens } from '@mcn-platform/models';
const Header = ({ onDownload, onPost, onPrint, settings: { showHeaderTitle, showHeaderActions, showNotesDownloadBtn, showNotesShareBtn, showNotesPrintBtn, }, }) => {
    const tokens = useTokens();
    const iconRootStyle = {
    // color: bgColorLight,
    };
    return (_jsxs(Stack, { display: "flex", direction: "row", justifyContent: "space-between", sx: {
            p: 1.5,
        }, children: [_jsx(Box, { children: showHeaderTitle && (_jsx(Typography, { variant: "subtitle1", className: "", fontWeight: 600, sx: {
                        flexGrow: 1,
                        color: (t) => (t.portal?.courseDeliveryPage?.notesBoxTextColor) || t.palette.contract.main,
                    }, children: tokens.getToken('notesLabel') })) }), showHeaderActions && (_jsxs(ButtonGroup, { variant: "text", "aria-label": "notes action btns", children: [showNotesDownloadBtn && (_jsx(Button, { onClick: onDownload, size: "small", "aria-label": "Download", sx: {
                            color: (t) => t.portal.courseDeliveryPage?.notesBoxIconColor || t.palette.contract.main,
                        }, children: _jsx(CloudDownloadOutlinedIcon, { sx: iconRootStyle }) })), showNotesShareBtn && (_jsx(Button, { onClick: onPost, size: "small", "aria-label": "Add Note", sx: {
                            color: (t) => t.portal.courseDeliveryPage?.notesBoxIconColor || t.palette.contract.main,
                        }, children: _jsx(ReplyAllOutlinedIcon, { sx: iconRootStyle }) })), showNotesPrintBtn && (_jsx(Button, { onClick: onPrint, size: "small", "aria-label": "Print", sx: {
                            color: (t) => t.portal.courseDeliveryPage?.notesBoxIconColor || t.palette.contract.main,
                        }, children: _jsx(LocalPrintshopOutlinedIcon, { sx: iconRootStyle }) }))] }))] }));
};
Header.defaultProps = {
    settings: {},
};
export default Header;
//# sourceMappingURL=Header.js.map